import React from 'react';
import { ReactComponent as Icon } from '../../../../../assets/icons/monCompte/rapport.svg';

function Rapport({ width = '30px', color = 'var(--main-color)', className = '', onClick }) {
  return (
    <Icon
      style={{ '--color': color, 'fill': 'var(--color)', 'cursor': onClick ? 'pointer' : 'auto' }}
      width={width}
      height={width}
      className={className + (onClick ? ' clickable-icon' : '')}
      onClick={onClick}
    />
  );
}

export default Rapport;
